import script from "./OrdemCompraAprovacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemCompraAprovacoes.vue?vue&type=script&setup=true&lang=js"

import "./OrdemCompraAprovacoes.vue?vue&type=style&index=0&id=5a8fd88d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8fd88d"]])

export default __exports__